import React from "react";
import { Navigate } from "react-router-dom";
import { useIsAdmin } from "@/hooks/use-user-role";
import { Card, CardContent } from "@/components/ui/card";

interface AdminGuardProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  redirect?: boolean;
}

const AdminGuard: React.FC<AdminGuardProps> = ({ 
  children, 
  fallback,
  redirect = false 
}) => {
  const { hasAdminAccess, isLoading } = useIsAdmin();

  if (isLoading) {
    return (
      <Card>
        <CardContent className="p-6">
          <div className="text-center text-muted-foreground">Loading...</div>
        </CardContent>
      </Card>
    );
  }

  if (!hasAdminAccess) {
    if (redirect) {
      return <Navigate to="/admin" replace />;
    }
    
    return fallback || (
      <Card>
        <CardContent className="p-6">
          <div className="text-center text-muted-foreground">
            Access denied. Administrator privileges required.
          </div>
        </CardContent>
      </Card>
    );
  }

  return <>{children}</>;
};

export default AdminGuard;